import axios from '@/plugins/axios'

export function getParkings(params = {}) {
  return axios.get('parking', {
    params,
  })
}

export function storeParking(data) {
  return axios.post('parking', data)
}

export function updateParking(id, data) {
  return axios.put(`parking/${id}`, data)
}

export function editParking(id) {
  return axios.get(`parking/${id}/edit`)
}

export function updateParkingStatus(data) {
  return axios.post(`parking/status`, data)
}

export function destroyParking(id) {
  return axios.delete(`parking/` + id)
}

export function getApplyAddParkings(params = {}) {
  return axios.get('parking/applyAddParking', {
    params,
  })
}
